<button class="mbp-btn" [class.primary]="type() === 'primary'" [class.secondary]="type() === 'secondary'"
  [class.error]="type() === 'error'" [class.full-width]="fullWidth()" type="button" [disabled]="disabled() || null"
  (click)="onClick()">
  @if (svg()) {
    <img [src]="svg()" alt="" aria-hidden="true" class="btn-icon" />
  }
  {{ text() }}
</button>
